export const iconFontAwesomeUsersPeopleUsersLine = (
	<i className="fa-solid fa-users-line"></i>
);
